module.exports = __webpack_public_path__ + "static/media/sub_boost.6f0c872b.png";